import Text from "../../../commons/Text";
import Title from "../../../commons/Title";
import classes from "./index.module.scss";
import imgWebp from "../images/challenge.webp";
import imgPng from "../images/challenge.png";

export default function Challenge() {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.image}>
            <picture>
              <source srcSet={imgWebp} type="image/webp" />
              <source srcSet={imgPng} type="image/png" />
              <img src={imgPng} alt="Challenge" width={876} />
            </picture>
          </div>
          <div className={classes.content}>
            <Title title="Challenge" number={"01"} className={classes.title} />
            <Text
              text={[
                `Our job was to develop a cannabis products e-store. It had to have a handy admin panel to support brands and delivery partners. 
                Also integral parts of this store should be:`,
              ]}
              className={classes.text}
            />
            <ul className={classes.list}>
              <li>
                <Text
                  text={[`the catalog in the AR`]}
                  className={classes.text}
                />
              </li>
              <li>
                <Text text={[`the NFT marketplace`]} className={classes.text} />
              </li>
              <li>
                <Text
                  text={[`convenient delivery.`]}
                  className={classes.text}
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
